
import Navbar from './Navbar';
import Footer from './home/Footer';
import WhatsAppButton from './WhatsAppButton';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  // Verificar si estamos en una página de detalle de propiedad
  const isPropertyDetailPage =
    location.pathname.startsWith('/propiedades/') || 
    location.pathname.startsWith('/property/');

  // Mostrar WhatsAppButton en todas las páginas EXCEPTO en móvil + detalle de propiedad
  // En móvil + detalle, MobileBookingBar maneja la visibilidad del WhatsAppButton
  const shouldShowWhatsAppButton = !(isMobile && isPropertyDetailPage);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16">
        {children}
      </main>
      <Footer />
      {shouldShowWhatsAppButton && <WhatsAppButton />}
    </div>
  );
};

export default Layout;
